import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

/**
 * Store to manage submenu state across the application
 * Ensures only one submenu can be open at a time
 */
interface SubmenuState {
  activeSubmenuId: string | null;
}

const initialState: SubmenuState = {
  activeSubmenuId: null,
};

export const SubmenuLocalStore = signalStore(
  withState(initialState),
  withMethods((store) => ({
    /**
     * Register a submenu as active and close any previously active submenu
     * @param submenuId Unique identifier for the submenu
     */
    registerActiveSubmenu(submenuId: string): void {
      if (store.activeSubmenuId() !== submenuId) {
        patchState(store, { activeSubmenuId: submenuId });
      }
    },

    /**
     * Unregister a submenu if it's the currently active one
     * @param submenuId Unique identifier for the submenu
     */
    unregisterSubmenu(submenuId: string): void {
      // Only clear if this submenu is the active one
      if (store.activeSubmenuId() === submenuId) {
        patchState(store, { activeSubmenuId: null });
      }
    },
  })),
);
